import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { DynamicFormField, DynamicFormSection } from 'interfaces/dynamic-form-field.interface';
import { generateGuid } from '@certemy/common';
import { DynamicFormComponent } from 'components/dynamic-form/dynamic-form.component';
import { DynamicForm } from './multiple-dynamic-form.interface';
import _get from 'lodash-es/get';
import _cloneDeep from 'lodash-es/cloneDeep';
import _uniq from 'lodash-es/uniq';

@Component({
  selector: 'cm-multiple-dynamic-form',
  templateUrl: './multiple-dynamic-form.component.html',
  styleUrls: ['./multiple-dynamic-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultipleDynamicFormComponent implements OnInit {
  @Input() dynamicForms: DynamicForm[] = [];
  @Input() previewMode = false;
  @Input() templateFormFields: DynamicFormField[];
  @Input() sections: DynamicFormSection[];

  @ViewChildren(DynamicFormComponent) dynamicFormComponents: QueryList<DynamicFormComponent>;

  showErrors = false;

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngOnInit() {
    if (!this.dynamicForms.length) {
      this.addForm();
    }
  }

  get dynamicFormErrors(): string[] {
    if (!this.dynamicFormComponents || !this.showErrors) {
      return [];
    }

    const errors = this.dynamicFormComponents.reduce((acc, comp) => [...acc, ...comp.getFormErrorMessages()], []);
    return _uniq(errors);
  }

  removeForm(formId: number) {
    if (this.dynamicForms.length > 1) {
      this.dynamicForms = this.dynamicForms.filter(form => form.dynamicFormInstanceId !== formId);
    }
  }

  addForm() {
    const newForm: DynamicForm = {
      fields: _cloneDeep(this.templateFormFields),
      dynamicFormInstanceId: generateGuid(),
    };
    this.dynamicForms = [...this.dynamicForms, newForm];
    this.showErrors = false;
  }

  isFormValid(): boolean {
    return this.dynamicFormComponents.map(form => form.dynamicForm.valid).every(valid => valid);
  }

  getFormData() {
    const dynamicFormsValueMap = this.dynamicFormComponents.reduce((formsValueMap, form) => {
      return {
        ...formsValueMap,
        [form.formId]: form.dynamicForm.value,
      };
    }, {});

    return this.dynamicForms.map(form => ({
      dynamicFormInstanceId: form.dynamicFormInstanceId,
      formValue: dynamicFormsValueMap[form.dynamicFormInstanceId],
    }));
  }

  validateAndGetFormData() {
    if (this.isFormValid()) {
      return this.getFormData();
    } else {
      this.showErrors = true;
      this.changeDetector.markForCheck();
      return null;
    }
  }
}
